(function () {
  // Promo banner video (in-grid "Fuel your day" style banner) — pause
  // autoplay when the visitor prefers reduced motion, matching this
  // project's existing pdp-clinical.js convention for decorative video.
  document.querySelectorAll('[data-yg-promo-video]').forEach(function (video) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.removeAttribute('autoplay');
      video.pause();
    }
  });

  function openDrawer(button) {
    var root = button.closest('collection-component') || document;
    var summary = root.querySelector('#main-collection-filters .mobile-facets__disclosure > summary');
    if (summary) summary.click();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-yg-filter-drawer-trigger]');
    if (button) {
      event.preventDefault();
      openDrawer(button);
      return;
    }

    var apply = event.target.closest('.mobile-facets__footer .button');
    if (!apply) return;

    var form = apply.closest('form');
    if (!form) return;
    form.querySelectorAll('input, select').forEach(function (field) {
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
})();
